var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 34,
    viewBox: "0 0 53 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3H53V30C53 32.2091 51.2091 34 49 34H4C1.79086 34 0 32.2091 0 30V3Z",
    fill: "#E7EAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.4V3.84H53C53 2.76087 52.1252 1.88606 51.0461 1.88606H18.4175C18.2966 1.88606 18.1769 1.86325 18.0645 1.81881L13.762 0.117683C13.5653 0.0399268 13.3558 0 13.1443 0H2.4C1.07452 0 0 1.07452 0 2.4Z",
    fill: "#C7D6FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.5656de2225c6972c4a0487e18fe126ba.svg";
export { ForwardRef as ReactComponent };